import { Text, Button } from '@clockout-dev/design-elements';
import { SEGMENTATION_MODE } from '../../../configuration.constants';
import styles from '../styles/userEligibilityForm.module.scss';

function ModeActionPanel({
    description,
    mode
}) {
    const isDisabled = mode === SEGMENTATION_MODE.DISABLED;
    const buttonText = isDisabled ? 'Active disabled mode' : 'Active open mode';

    return (
        <>
            <div className={styles.notice}>
                <Text as="span" size="s" className={styles.noticeText}>
                    {description}
                </Text>
            </div>

            <div className={styles.actionPanelButtons}>
                <Button
                    type="submit"
                    block
                >
                    {buttonText}
                </Button>
            </div>
        </>
    );
}

export default ModeActionPanel;
